<template>
  <div class="func_detail">
    <v-tabs grow
            v-model="tabs"
            background-color="#eeeef0">
      <v-tab class="text-capitalize">{{ $t('label_function') }}</v-tab>
      <v-tab class="text-capitalize">{{ $t('label_button') }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <func-detail @getData="getData"
                     :func_disabled="func_disabled"
                     :func_data="func_data"
                     @func_cancel="func_cancel"
                     @getBtnClientType="getBtnClientType"></func-detail>
      </v-tab-item>
      <v-tab-item>
        <btn-detail :module_uuid="func_data.module_uuid"
                    :list="btnList"
                    :client_type="client_type"
                    :version_uuid="func_data.version_uuid"
                    @success="success"
                    @cancel="btn_cancel"></btn-detail>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import {
  getBusinessList,
  get_func_add,
  get_func_update,
  get_func_del,
  get_func_detail,
} from '@/service/api/func_module'
import { getDataByName } from '@/service/api/data_dictionary'
// import iconGroup from '@/components/iconGroup'
// import multiText from '@/components/multi_text'
import funcDetail from '../add_func/func'
import btnDetail from '../add_func/btn'
export default {
  components: { funcDetail, btnDetail },
  props: {},
  data () {
    return {
      uuid: '',
      func_disabled: true,
      func_data: {
        function_name: '',
        function_shortcode: '',
        function_description: '',
        table_uuid: '',
        function_type_uuid: '',
        module_uuid: '',
        org_level_uuid: '', // 多选
        status_uuid: '',
        uuid: '',
        function_id: '',
      },
      top_module: [],
      data_table: [],
      func_type: [],
      unit_data: [],
      btnList: [],
      client_type: [],
      // disabled: true,
      tabs: 0,
    }
  },
  created () { },
  async mounted () {
    const name = this.$store.getters.subPage_name
    const uuid = this.$route.params.uuid || this.$store.state.uuid
    // this.uuid = "c37ba31d-cd25-4771-9bcc-3cd30b27ebcc"
    // this.$store.commit('set_uuid',this.uuid)
    this.uuid = uuid
    // 功能详情
    if (this.uuid) {
      await this.getDetail()
      if (!this.$store.state.iconstatus) {
        this.func_disabled = false
        this.$store.commit('set_iconstatus', false)
      }
    }
  },
  methods: {
    async getDetail () {
      const detail = await get_func_detail({
        uuid: this.uuid,
      })
      if (detail.code == 200) {
        // if (detail.data.org_level_uuid) {
        //   detail.data.org_level_uuid = detail.data.org_level_uuid.split(',')
        // } else {
        //   detail.data.org_level_uuid = []
        // }
        this.func_data = detail.data
        this.btnList = detail.mrbase_sys_function_buttons
      }
    },
    async func_cancel () {
      if (!this.$store.state.uuid) {
        this.$router.go(-1)
      } else {
        const detail = await get_func_detail({
          uuid: this.uuid,
        })
        // if (detail.data.org_level_uuid) {
        //   detail.data.org_level_uuid = detail.data.org_level_uuid.split(',')
        // }
        this.func_data = detail.data
      }
    },
    async btn_cancel () {
      if (!this.$store.state.uuid) return
      const detail = await get_func_detail({
        uuid: this.uuid,
      })
      // if (detail.data.org_level_uuid) {
      //   detail.data.org_level_uuid = detail.data.org_level_uuid.split(',')
      // }
      this.btnList = detail.mrbase_sys_function_buttons
    },
    getBtnClientType (arr) {
      this.client_type = arr
    },
    handleReturn () {
      // console.log('返回')
    },
    handleEdit () {
      this.disabled = !this.disabled
    },
    handleDel () {
      // console.log('删除')
    },
    async getData (obj) {
      const update = await get_func_update({
        ...obj,
        // org_level_uuid: this.$store.state.userData.org_level_uuid,
      })
      if (update.code == 200) {
        this.$Message({ text: this.$t('message_The_operation_was_successful') })

        // 这里的问题  明天记着
        this.func_disabled = !this.func_disabled
        // if (!this.$store.state.iconstatus) {
        //   this.func_disabled = false
        //   this.$store.commit('set_iconstatus', false)
        // }
        await this.getDetail()
      }
    },
    // 提交按钮
    async success (arr) { },
  },
  computed: {},
  watch: {
    // 'func_data.client_type_uuid'(val) {
    //   console.log(val)
    // },
    // btnList: {
    //   handler(val) {
    //     console.log(val,'detail')
    //   },
    //   deep: true
    // }
  },
}
</script>

<style scoped>
.func_detail /deep/ .v-tab--active {
  color: #000000;
}
.func_detail /deep/ .v-dialog::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.status {
  color: #fff;
  background-color: #18a874;
  width: 40px;
  height: 25px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  font-size: 12px;
  display: inline-block;
  line-height: 25px;
  text-align: center;
}
.is_used {
  background-color: #dedede;
}
.card_title {
  padding: 8px 0 8px 10px !important;
  display: flex;
  justify-content: space-between;
  font-size: 14px !important;
  color: #fff;
  background-color: #000000;
}
.close_dialog {
  width: 32px;
  text-align: center;
  cursor: pointer;
}
</style>
